import {
  API_DASHBOARD,
  API_DRIVE,
  API_GESTOR,
  API_KPI,
  API_LTE,
  API_PREDICT,
  API_RAJANT,
  API_SERVER,
  API_TOPOLOGY,
  APIS_MAPS,
} from "@/interfaces/SmartLink/Apis";
import { APIS_GENERAL } from "@/interfaces/SmartLink/General";
import { ref, computed, ComputedRef } from "vue";

const finalURL = ref(process.env.VUE_APP_URL_APIS ?? "");

/**
 * URL que solo se usará para el DEMO ya que estoy obteniendo datos de una base de datos antigua
 */
const finalURLPRED = ref(
  process.env.VUE_APP_NAME_PROJECT === "SmartLinkDEMO"
    ? process.env.VUE_APP_URL_APIS
    : process.env.VUE_APP_URL_APIS,
);
const TIMEOUT =
  process.env.VUE_APP_NAME_PROJECT === "SmartLinkNacozari" ? 120000 : 60000; // Tiempo de espera para las peticiones (en milisegundos)

/**
 * Esta Función sirve para que hayan varios proyectos a la vez dentro del mismo Smartlink
 * Se llama desde PrincipalPageView, donde se selecciona el proyecto a verse, y cambia los valores de la API
 * Para este caso solo hay de Cananea y de Colahuasi
 * @param valor Valor asignado para cada constante
 */
export function changeURL(valor: number) {

  const url: any = {
    0: process.env.VUE_APP_URL_APIS_CANANEA,
    1: process.env.VUE_APP_URL_APIS_COLLAHUASI,
    2: process.env.VUE_APP_URL_APIS_NACOZARI,
    3: process.env.VUE_APP_URL_APIS_TEPEACA,
    4: process.env.VUE_APP_URL_APIS_LIMA,
    5: process.env.VUE_APP_URL_APIS_DEMO,

    CANANEA: process.env.VUE_APP_URL_APIS_CANANEA,
    COLLAHUASI: process.env.VUE_APP_URL_APIS_COLLAHUASI,
    NACOZARI: process.env.VUE_APP_URL_APIS_NACOZARI,
    TEPEACA: process.env.VUE_APP_URL_APIS_TEPEACA,
    LIMA: process.env.VUE_APP_URL_APIS_LIMA,
    DEMO: process.env.VUE_APP_URL_APIS_DEMO,
  }

  if (url[valor]) {
    finalURL.value = url[valor]!;
  }
}

const APIS: ComputedRef<APIS_GENERAL> = computed(() => {
  return {
    kpi: {
      getAllDataKPI: `${finalURL.value}kpi/getAllDataKPI`,
      getcostwired: `${finalURL.value}kpi/getCostWiredpeers`,
      getcostwireless: `${finalURL.value}kpi/getCostWirelesspeers`,
      getAllLatency: `${finalURL.value}kpi/getAllLatency`,
      getLastConectionHaultruck: `${finalURL.value}kpi/getLastConectionHaultruck`,
      getCountLastConectionHaultruck: `${finalURL.value}kpi/getCountLastConectionHaultruck`,
      sendMail: `${finalURL.value}sendMail/sendMail`,
    },
    csv: {
      getDataInven: `${finalURL.value}csv/getDataInventory`,
      editDataInven: `${finalURL.value}csv/editDataInventory`,
      editDataByName: `${finalURL.value}csv/editDataInventoryByName`,
      insertDataInven: `${finalURL.value}csv/insertDataInventory`,
    },
    dashboard: {
      getKPIDashboard: `${finalURL.value}dashboard/getKPIDashboard`,
      getOperability: `${finalURL.value}dashboard/getAllOperability`,
      alarmtodash: `${finalURL.value}dashboard/getAlarmToDashBoard`,
      alarmrectodash: `${finalURL.value}dashboard/getAlarmRecurrentToDashBoard`,
    },
    topology: {
      getGraphTopo: `${finalURL.value}topology/getGraphTopologyData`,
      getTableTopo: `${finalURL.value}topology/getTableTopologyData`,
      getStatusLog: `${finalURL.value}topology/getStatusLogGraph`,
      getAllTopoData: `${finalURL.value}topology/getAllTopologyData`,
      getSNMPDataByIP: `${finalURL.value}topology/getSNMPDataByIP`,
      getAllOperaByIP: `${finalURL.value}topology/getAllOperabilityByIP`,
      getAllOpLastDay: `${finalURL.value}topology/getAllOperabilityLastDay`,
    },

    general: {
      inventory: `${finalURL.value}inventario`,
      getAllInventoryData: `${finalURL.value}inventario/getAllInventoryData`,
      inventoryOID: `${finalURL.value}inventarioOID`,
      getSubtypeInv: `${finalURL.value}inventario/getSubTypeInventory`,
      getTypeInv: `${finalURL.value}inventario/getTypeInventory`,
      getMarkInventory: `${finalURL.value}inventario/getMarkInventory`,
      getSNMPInventory: `${finalURL.value}inventario/getSNMPInventory`,
      deleteDataInDB: `${finalURL.value}inventario/deleteDataInDB`,
      getDBStatus: `${finalURL.value}dbstatus/getDataBaseStatus`,
      login: `${finalURL.value}login`,
      pagestatus: `${finalURL.value}pagestatus`,
    },
    /** *****************************FALTA GENERAL ****************************** */

    ia: {
      getClusterData: `${finalURL.value}clustering/getClusteringData`,
      get12HourCluster: `${finalURL.value}clustering/getLast12HourClustering`,
      getClusteringDataTransform: `${finalURL.value}clustering/getClusteringDataTransform`,
    },

    predict: {
      getAllSNRData: `${finalURLPRED.value}predict/snr/getAllPredSNRData`,
      getTabSNRByIP: `${finalURLPRED.value}predict/snr/getPredTabSNRDataByIP`,
      getPredSNRByIP: `${finalURLPRED.value}predict/snr/getPredSNRDataByIP`,
      getRealSNRByIP: `${finalURLPRED.value}predict/snr/getRealSNRDataByIP`,
      getAllPredRXData: `${finalURLPRED.value}predict/rxlevel/getAllPredictRXLVLData`,
      getPredTabData: `${finalURLPRED.value}predict/rxlevel/getPredTableRXLVLData`,
      getPredDataByIP: `${finalURLPRED.value}predict/rxlevel/getAllRXLVLPredDataByIP`,
      getRealDataByIP: `${finalURLPRED.value}predict/rxlevel/getAllRXLVLRealDataByIP`,
    },
    lte: {
      getIPLTE: `${finalURL.value}lte/getIPLTE`,
      getAllLTEData: `${finalURL.value}lte/getAllLTEData`,
      getAllGraphData: `${finalURL.value}lte/getAllLTEDataGraph`,
      lte1data: `${finalURL.value}lte/getLTE1Data`, //(no se en que consiste esto, verificar)
      graphsnmpmodem: `${finalURL.value}lte/getSNMPModemALLDataByIP`,
    },
    server: {
      getIPServer: `${finalURL.value}server/getIPServer`,
      getAllServData: `${finalURL.value}server/getAllServerData`,
      getAllServGraph: `${finalURL.value}server/getAllServerGraphData`,
      getVirMacServer: `${finalURL.value}server/getVirMacServer`,
      getVirMacByIP: `${finalURL.value}server/getVirMacByIP`,
      getAlarmVirMac: `${finalURL.value}server/getAlarmVirMac`,
    },
    maps: {
      getAllLatLngAP: `${finalURL.value}maps/getAllLatLngPMPAP`,
      getAllLatLngSM: `${finalURL.value}maps/getAllLatLngPMPSM`,
      getAllLatLngRAJ: `${finalURL.value}maps/getAllLatLngRAJANT`,
      getAllPolylines: `${finalURL.value}maps/getAllPolylines`,
      getAllLatLngANY: `${finalURL.value}maps/getAllLatLngANY`,
      getAllLatLngGPS: `${finalURL.value}maps/getAllLatLngGPSTEST`,
      getPositTrucks: `${finalURL.value}maps/getPositionHaulTrucks`,
      getAllTrucks: `${finalURL.value}maps/getAllHaulTrucks`,
    },
    drive: {
      geAllIPDrive: `${finalURL.value}drive/geAllIPDrive`,
      getInfoDriveByIP: `${finalURL.value}drive/getInfoDriveByIP`,
      postHeatMap: `${finalURL.value}drive/postHeatMap`,
      geAllIPDriveRAJANT: `${finalURL.value}drive/geAllIPDriveRajant`,
      getInfoDriveRAJANTByIP: `${finalURL.value}drive/getInfoDriveRajantByIP`,
      postHeatMapRAJANT: `${finalURL.value}drive/postHeatMapRAJANT`,
    },
    instamesh: {
      getWirelessByIP: `${finalURL.value}instamesh/getAllWirelessDataByIP`,
      getWiredByIP: `${finalURL.value}instamesh/getAllWiredDataByIP`,
      getTempByIP: `${finalURL.value}instamesh/getAllTempDataByIP`,
      getCostByIP: `${finalURL.value}instamesh/getAllCostDataByIP`,
      getCostJRByIP: `${finalURL.value}instamesh/getAllCostJRDataByIP`,
    },
    report: {
      operability: `${finalURL.value}report/getWorstOperability`,
      qualitylap: `${finalURL.value}report/getWorstQualityLAP`,
      qualitysnr: `${finalURL.value}report/getWorstQualitySNR`,
      latency: `${finalURL.value}report/getWorstLatency`,
      tenlatency: `${finalURL.value}report/getTENWorstLatency`,
      alarmData: `${finalURL.value}report/getAlarmData`,
      getIPreport: `${finalURL.value}report/getDataHistory`,
      getTopFive: `${finalURL.value}report/getTopFiveLatency`,
      getWorstLnLgIP: `${finalURL.value}report/getWorstLatLngByIp`,
      getWorstLateIP: `${finalURL.value}report/getWorstLatencyByIp`,
    },
    yaml: {
      getYAML: `${finalURL.value}rutaYAML/getYAML`,
      editYAML: `${finalURL.value}rutaYAML/editYAML`,
    },
    gestor: {
      getLastLTE: `${finalURL.value}GestorHCGLink/estadisticas/getLastLTE`,
      getLast30DaysLTE: `${finalURL.value}GestorHCGLink/estadisticas/getLast30DaysLTE`,
      getMaxDatesLTE: `${finalURL.value}GestorHCGLink/estadisticas/getMaxDatesLTE`,
    },
    monitoreo: {
      resetService: `${finalURL.value}GestorHCGLink/monitoreo/resetService`,
    },
    chatGPT: {
      preguntar: `${finalURL.value}chatIA/preguntar`,
      clear: `${finalURL.value}chatIA/clear`,
    },
    webSocket: {
      wss: `${process.env.VUE_APP_URL_WSS}`,
    },
  };
});

export const AUTH_LOGIN_URL = process.env.VUE_APP_URL_APIS_LOGIN || "";

export const APIS_TOPOLOGY = computed<API_TOPOLOGY>(() => {
  return {
    getGraphTopo: `${finalURL.value}topology/getGraphTopologyData`,
    getTableTopo: `${finalURL.value}topology/getTableTopologyData`,
    getStatusLog: `${finalURL.value}topology/getStatusLogGraph`,
    getAllTopoData: `${finalURL.value}topology/getAllTopologyData`,
    getClientStatusData: `${finalURL.value}topology/getClientStatusData`,
    getClientStatusDataByIPS: `${finalURL.value}topology/getClientStatusDataByIPS`,
    getSNMPDataByIP: `${finalURL.value}topology/getSNMPDataByIP`,
    getAllOperaByIP: `${finalURL.value}topology/getAllOperabilityByIP`,
    getAllOpLastDay: `${finalURL.value}topology/getAllOperabilityLastDay`,
  };
});

export const APIS_RAJANT = computed<API_RAJANT>(() => {
  return {
    getAllRajantData: `${finalURL.value}instamesh/getAllRajantData`,
    getWirelessByIP: `${finalURL.value}instamesh/getAllWirelessDataByIP`,
    getWiredByIP: `${finalURL.value}instamesh/getAllWiredDataByIP`,
    getTempByIP: `${finalURL.value}instamesh/getAllTempDataByIP`,
    getCostByIP: `${finalURL.value}instamesh/getAllCostDataByIP`,
    getCostJRByIP: `${finalURL.value}instamesh/getAllCostJRDataByIP`,
  };
});

export const APIS_DASHBOARD = computed<API_DASHBOARD>(() => {
  return {
    getAllLatencyLastMinute: `${finalURL.value}dashboard/getAllLatencyLastMinute`,
    getLastRXLVLandSNR: `${finalURL.value}dashboard/getLastRXLVLandSNR`,
    getKPIDashboard: `${finalURL.value}dashboard/getKPIDashboard`,
    getOperability: `${finalURL.value}dashboard/getAllOperability`,
    alarmtodash: `${finalURL.value}dashboard/getAlarmToDashBoard`,
    alarmrectodash: `${finalURL.value}dashboard/getAlarmRecurrentToDashBoard`,
  };
});

export const APIS_SERVER = computed<API_SERVER>(() => {
  return {
    getIPServer: `${finalURL.value}server/getIPServer`,
    getAllServData: `${finalURL.value}server/getAllServerData`,
    getAllServGraph: `${finalURL.value}server/getAllServerGraphData`,
    getVirMacServer: `${finalURL.value}server/getVirMacServer`,
    getVirMacByIP: `${finalURL.value}server/getVirMacByIP`,
    getAlarmVirMac: `${finalURL.value}server/getAlarmVirMac`,
  };
});

export const APIS_GESTOR = computed<API_GESTOR>(() => {
  return {
    getLastLTE: `${finalURL.value}GestorHCGLink/estadisticas/getLastLTE`,
    getLast30DaysLTE: `${finalURL.value}GestorHCGLink/estadisticas/getLast30DaysLTE`,
    getMaxDatesLTE: `${finalURL.value}GestorHCGLink/estadisticas/getMaxDatesLTE`,
  };
});

export const APIS_LTE = computed<API_LTE>(() => {
  return {
    getIPLTE: `${finalURL.value}lte/getIPLTE`,
    getAllLTEData: `${finalURL.value}lte/getAllLTEData`,
    getAllGraphData: `${finalURL.value}lte/getAllLTEDataGraph`,
    lte1data: `${finalURL.value}lte/getLTE1Data`, //(no se en que consiste esto, verificar)
    graphsnmpmodem: `${finalURL.value}lte/getSNMPModemALLDataByIP`,
  };
});

export const APIS_PREDICT = computed<API_PREDICT>(() => {
  return {
    getAllSNRData: `${finalURLPRED.value}predict/snr/getAllPredSNRData`,
    getTabSNRByIP: `${finalURLPRED.value}predict/snr/getPredTabSNRDataByIP`,
    getPredSNRByIP: `${finalURLPRED.value}predict/snr/getPredSNRDataByIP`,
    getRealSNRByIP: `${finalURLPRED.value}predict/snr/getRealSNRDataByIP`,
    getAllPredRXData: `${finalURLPRED.value}predict/rxlevel/getAllPredictRXLVLData`,
    getPredTabData: `${finalURLPRED.value}predict/rxlevel/getPredTableRXLVLData`,
    getPredDataByIP: `${finalURLPRED.value}predict/rxlevel/getAllRXLVLPredDataByIP`,
    getRealDataByIP: `${finalURLPRED.value}predict/rxlevel/getAllRXLVLRealDataByIP`,
    getDataTemperaturePredictLastMinute: `${finalURLPRED.value}predict/temperature/getDataPredictLastMinute`,
  };
});

export const APIS_KPI = computed<API_KPI>(() => {
  return {
    getAllDataKPI: `${finalURL.value}kpi/getAllDataKPI`,
    getcostwired: `${finalURL.value}kpi/getCostWiredpeers`,
    getcostwireless: `${finalURL.value}kpi/getCostWirelesspeers`,
    getAllTempAndVoltageLastMinute: `${finalURL.value}kpi/getAllTempAndVoltageLastMinute`,
    getAllCostLastMinute: `${finalURL.value}kpi/getAllCostLastMinute`,
    sendMail: `${finalURL.value}sendMail/sendMail`,
    getAllLatency: `${finalURL.value}kpi/getAllLatency`,
    getAllQualityData: `${finalURL.value}kpi/getAllQualityData`,
    getAllRajantData: `${finalURL.value}kpi/getAllRajantData`,
    getAllSensoresData: `${finalURL.value}kpi/getAllSensoresData`,
  };
});

export const APIS_MAP = computed<APIS_MAPS>(() => {
  return {
    getAllInfoMap: `${finalURL.value}dashboard/getAllInfoMap`,
    getAllLatLngInfo: `${finalURL.value}dashboard/getAllLatLngInfo`,
    getAllBandWidth: `${finalURL.value}dashboard/getAllBandWidth`,
    getAllUsers: `${finalURL.value}dashboard/getAllUsers`,
    getClusteringDataTemperatureToFront: `${finalURL.value}clustering/getClusteringDataTemperatureToFront`,
    getClusteringDataTransform: `${finalURL.value}clustering/getClusteringDataTransform`,
    getAllLatLngAP: `${finalURL.value}maps/getAllLatLngPMPAP`,
    getAllLatLngSM: `${finalURL.value}maps/getAllLatLngPMPSM`,
    getAllLatLngRAJ: `${finalURL.value}maps/getAllLatLngRAJANT`,
    getAllPolylines: `${finalURL.value}maps/getAllPolylines`,
  };
});

export const APIS_DRIVE = computed<API_DRIVE>(() => {
  return {
    geAllIPDrive: `${finalURL.value}drive/geAllIPDrive`,
    getInfoDriveByIP: `${finalURL.value}drive/getInfoDriveByIP`,
    postHeatMap: `${finalURL.value}drive/postHeatMap`,
    geAllIPDriveRAJANT: `${finalURL.value}drive/geAllIPDriveRajant`,
    getInfoDriveRAJANTByIP: `${finalURL.value}drive/getInfoDriveRajantByIP`,
    postHeatMapRAJANT: `${finalURL.value}drive/postHeatMapRAJANT`,
    killProcessDrive: `${finalURL.value}drive/killProcessDrive`,
    killProccessAll: `${finalURL.value}drive/killProccessAll`,
    postBandWidth: `${finalURL.value}drive/postBandWidth`,
    getRajantIPS: `${finalURL.value}drive/getRajantIPS`,
    getAllRajantIPStoMAP: `${finalURL.value}drive/getAllRajantIPStoMAP`,
    getRajantGPS: `${finalURL.value}drive/getRajantGPS`,
    getRajantPerfomance: `${finalURL.value}drive/getRajantPerfomance`,
    getAllClientDevice: `${finalURL.value}drive/getAllClientDevice`,
    validateRunScripts: `${finalURL.value}drive/getRUNPetition`,
    getLocationDriveByIP: `${finalURL.value}drive/getLocationDriveByIP`,
    getLatencyDriveByIP: `${finalURL.value}drive/getLatencyDriveByIP`,
    getAllDriveClientsDevices: `${finalURL.value}drive/getAllDriveClientsDevices`,
  };
});

export const APIS_REPORT = computed(() => {
  return {
    generarReporte: `${finalURL.value}report/generarReporte`,
    enviarReporte: `${finalURL.value}report/enviarReporte`,
  };
})

export const APIS_INVENTORY = computed(() => {
  return {
    getAllInventoryData: `${finalURL.value}inventario/getAllInventoryData`,
    postAddInventoryData: `${finalURL.value}inventario/postAddInventoryData`,
    postEditInventoryData: `${finalURL.value}inventario/postEditInventoryData`,
    postDeleteInventoryData: `${finalURL.value}inventario/postDeleteInventoryData`,
    inventoryOID: `${finalURL.value}inventarioOID`,
    getSubtypeInv: `${finalURL.value}inventario/getSubTypeInventory`,
    getTypeInv: `${finalURL.value}inventario/getTypeInventory`,
    getSNMPInventory: `${finalURL.value}inventario/getSNMPInventory`,
    getMarkInventory: `${finalURL.value}inventario/getMarkInventory`,
    getDBStatus: `${finalURL.value}dbstatus/getDataBaseStatus`,
    login: `${finalURL.value}login`,
    pagestatus: `${finalURL.value}pagestatus`,
  };
});

export const APIS_RAOS_INVENTORY = computed(() => {
  return {
    getAllPerforadorasData: `${finalURL.value}inventario/getAllPerforadorasData`,
    getAllUsersData: `${finalURL.value}inventario/getAllUsersData`,
    postAddUserData: `${finalURL.value}inventario/postAddUserData`,
    postEditUserData: `${finalURL.value}inventario/postEditUserData`,
    postDeleteUserData: `${finalURL.value}inventario/postDeleteUserData`,
  };
});

export const APIS_RAOS_DATA = computed(() => {
  return {
    getAllRajantRAOSData: `${finalURL.value}raos/getAllRajantRAOSData`,
    getAllLatenciaRAOSData: `${finalURL.value}raos/getAllLatenciaRAOSData`,
    getAllSensoresRAOSData: `${finalURL.value}raos/getAllSensoresRAOSData`,
    getAllRajantRAOSDataBYip: `${finalURL.value}raos/getAllRajantRAOSDataBYip`,
    getAllLatenciaRAOSDataBYip: `${finalURL.value}raos/getAllLatenciaRAOSDataBYip`,
    getAllSensoresRAOSDataBYip: `${finalURL.value}raos/getAllSensoresRAOSDataBYip`,
    getAllBandWidthByIP: `${finalURL.value}raos/getAllBandWidthByIP`,
  };
});

export const APIS_RAOS_REPORT = computed(() => {
  return {
    getLatencyHistoryReport: `${finalURL.value}raos/getLatencyHistoryReport`,
    getRajantDataHistoryReport: `${finalURL.value}raos/getRajantDataHistoryReport`,
    getSensoresHistoryReport: `${finalURL.value}raos/getSensoresHistoryReport`,
    getOperabilityHistoryReport: `${finalURL.value}raos/getOperabilityHistoryReport`,
    getBandWidthDataHistoryReport: `${finalURL.value}raos/getBandWidthDataHistoryReport`,
  };
});

export const APIS_SQLLITE_REPORT = computed(() => {
  return {
    getExtractionRuns: `${finalURL.value}sqlLite/getExtractionRuns`,
    getHosts: `${finalURL.value}sqlLite/getHosts`,
    getDatastores: `${finalURL.value}sqlLite/getDatastores`,
    getVms: `${finalURL.value}sqlLite/getVms`,
    getAlarms: `${finalURL.value}sqlLite/getAlarms`,
    getHistorico: `${finalURL.value}sqlLite/getHistorico`,
  };
});

export const APIS_IA = computed(() => {
  return {
    postProcesarConsulta: `${finalURL.value}ia/postProcesarConsulta`,
    getClusteringDataTransform: `${finalURL.value}clustering/getClusteringDataTransform`,
    getClusteringDataTemperatureToFront: `${finalURL.value}clustering/getClusteringDataTemperatureToFront`,
    // getUserLoginToken: `https://192.168.3.116:443/api/auth/login`,
    // wsSmartlink: `https://192.168.3.116:443/ws-smartlink`
    getUserLoginToken: `https://sla.hcgpe.com:8443/api/auth/login`,
    wsSmartlink: `https://sla.hcgpe.com:8443/ws-smartlink`
  };
});

// export const APIS_RAOS_REPORT = computed(() => {
//     return {
//         getAllPerforadorasRAOS: `${finalURL.value}report/getAllPerforadorasRAOS`,
//     }
// })


export const APIS_TELEMETRY = computed(() => {
  return {
    history: `${finalURL.value}telemetry/history`,
    csv: `${finalURL.value}telemetry/export-csv`,
  };
});

export const TIMEOUTTIME = TIMEOUT; // Exportar el tiempo de espera para las peticiones
export const TIMEOUTTIMEREPORT = 300000;

export const MINAS_CONFIG = {
  CANANEA: {
    index: 0,
    name: process.env.VUE_APP_NAME_PROJECT_CANANEA,
    lat: process.env.VUE_APP_MAP_LAT_CANANEA,
    lng: process.env.VUE_APP_MAP_LNG_CANANEA,
    zoom: process.env.VUE_APP_MAP_ZOOM_CANANEA,
  },
  COLLAHUASI: {
    index: 1,
    name: process.env.VUE_APP_NAME_PROJECT_COLLAHUASI,
    lat: process.env.VUE_APP_MAP_LAT_COLLAHUASI,
    lng: process.env.VUE_APP_MAP_LNG_COLLAHUASI,
    zoom: process.env.VUE_APP_MAP_ZOOM_COLLAHUASI,
  },
  NACOZARI: {
    index: 2,
    name: process.env.VUE_APP_NAME_PROJECT_NACOZARI,
    lat: process.env.VUE_APP_MAP_LAT_NACOZARI,
    lng: process.env.VUE_APP_MAP_LNG_NACOZARI,
    zoom: process.env.VUE_APP_MAP_ZOOM_NACOZARI,
  }
  ,
  TEPEACA: {
    index: 3,
    name: 'SmartLinkTepeaca',
    lat: process.env.VUE_APP_MAP_LAT_CANANEA,
    lng: process.env.VUE_APP_MAP_LNG_CANANEA,
    zoom: process.env.VUE_APP_MAP_ZOOM_CANANEA,
  },
  LIMA: {
    index: 4,
    name: process.env.VUE_APP_NAME_PROJECT_LIMA,
    lat: process.env.VUE_APP_MAP_LAT_LIMA,
    lng: process.env.VUE_APP_MAP_LNG_LIMA,
    zoom: process.env.VUE_APP_MAP_ZOOM_LIMA,
  },
  DEMO: {
    index: 5,
    name: process.env.VUE_APP_NAME_PROJECT_DEMO,
    lat: process.env.VUE_APP_MAP_LAT_DEMO,
    lng: process.env.VUE_APP_MAP_LNG_DEMO,
    zoom: process.env.VUE_APP_MAP_ZOOM_DEMO,
  },

};

export default {
  APIS,
};